console.log("Proteus Treatments - 0.07");

if(getParam("qa")){
  let variation = "v1";
  if(getParam("var")){
    variation = getParam("var");
  }
  window.sessionStorage.setItem(getParam("qa"), variation);
}

/* ----------

  [DS-03] AOV Incentivization
  v1: $40 magnet -- $70 free shipping -- $100 chillies -- $150 dish towels

---------- */

waitUntil(() => {
  return window.sessionStorage.getItem("DS-03") || !!false;
}).then(() => {

  observeSelector('body', doc => {

    let exp_id = "DS-03";
    let exp_var = "v1";
    console.log(`init [${exp_id}] -- 0.04 -- ${exp_var}`);

    const incentives_goals = [
      {
        threshold: 4000,
        message: "FREE MAGNET",
        label: "magnet",
        var_id: "31903251169362"
      },
      {
        threshold: 7000,
        message: "FREE SHIPPING",
        label: "free shipping",
        var_id: "none"
      },
      {
        threshold: 10000,
        message: "FREE CHILLIES",
        label: "chillies",
        var_id: "42725178704043"
      },
      {
        threshold: 15000,
        message: "FREE DISH TOWELS",
        label: "towels",
        var_id: "40806724337835"
      }
    ];

    const checkmark_svg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="800px" width="800px" version="1.1" id="Capa_1" viewBox="0 0 17.837 17.837" xml:space="preserve">
    <g>
      <path d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27   c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0   L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z"/>
    </g>
    </svg>`;

    // inject treatment styles
    doc.insertAdjacentHTML("afterbegin", `
      <style>
        .js-hidden{
          display: none;
          opacity: 0;
          position: absolute;
          left: -9999px;
        }

        /* --- START INCENTIVES MODULE --- */

          .js-incentives{
            color: #fff;
          }

          #slidecarthq .slidecarthq.cartEmpty > .js-incentives{
            display: none;
          }

          .js-incentives-mesage{
            font-size: 13px;
            color: #000;
            font-family: "Avenir", "Avenir", "Avenir Next", sans-serif;
            line-height: 1.6em;
            letter-spacing: .1em;
            text-transform: uppercase;
            text-align: center;
            margin-bottom: .5rem;
          }

          .js-incentives-mesage strong{
            font-weight: 900;
          }

          .js-incentives--bar{
            background: #f4ac3c;
            border-radius: 25px;
            height: 6px;
            position: relative;
            margin-bottom: 2rem;
          }

          .js-incentives--bar--filled{
            transition: .5s ease width;
            width: 10%;
            background: #d5137b;
            border-radius: 25px;
            height: 6px;
            position: absolute;
            left: 0;
            top: 0;
          }

          .js-incentives--goals{

          }

          .js-incentives--threshold{
            position: absolute;
            top: 0;
          }

          .js-incentives--threshold--dot{
            width: 18px;
            height: 18px;
            border-radius: 100%;
            background: #f4ac3c;
            position: absolute;
            top: -6px;
            left: -18px;
          }

          .js-incentives--threshold.js-threshold-met .js-incentives--threshold--dot{
            background: #d5137b;
          }

          .js-incentives--threshold--dot--icon{
            transition: .5s ease opacity;
            opacity: 0;
            padding: 3px;
          }

          .js-incentives--threshold.js-threshold-met .js-incentives--threshold--dot--icon{
            opacity: 1;
          }

          .js-incentives--threshold--dot--icon svg{
            position: absolute;
            top: 15%;
            left: 15%;
            height: 70%;
            width: 70%;
            fill: #fff !important;
          }

          .js-incentives--threshold--label{
            color: #000;
            position: absolute;
            font-size: 11px;
            top: 16px;
            right: -30px;
            width: 78px;
            text-align: center;
            opacity: 1;
          }

          .js-incentives--threshold--label span:first-child,
          .js-incentives--threshold.js-reveal .js-incentives--threshold--label span:last-child{
            display: none;
          }

          .js-incentives--threshold.js-reveal .js-incentives--threshold--label span:first-child,
          .js-incentives--threshold--label span:last-child{
            display: block;
          }

          .js-incentives--threshold.js-reveal .js-incentives--threshold--label{
            font-weight: 900;
          }

      </style>
    `);

    observeSelector('.cart__mini-wrapper > div > div.tracking-widest', cart_rewards => {

      cart_rewards.querySelector('div:first-child').classList.add("js-hidden");

      // auto open cart
      if(getParam("cart") == "open"){
        waitUntil(() => {
          return document.querySelectorAll('.cart__mini-wrapper .cart__main').length > 0;
        }).then(() => {
          setTimeout(() => {
            document.querySelector('header.header > div:last-child > button:last-child').click();
          }, 500);
        }).catch();
      }

      let thresholds_html = "";
      // set max to largest threshold's setting (which is expected to be the last item of the array)
      let incentives_max = incentives_goals[incentives_goals.length -1].threshold;

      for(let i = 0; i < incentives_goals.length; i++){
        let range_position = (incentives_goals[i].threshold / incentives_max) * 100;
        thresholds_html = thresholds_html + `
          <div class="js-incentives--threshold" data-threshold="${incentives_goals[i].threshold}" data-var-id="${incentives_goals[i].var_id}" style="left: ${range_position}%;" data-label="${incentives_goals[i].message}">
            <div class="js-incentives--threshold--dot">
              <div class="js-incentives--threshold--dot--icon">${checkmark_svg}</div>
            </div>
            <div class="js-incentives--threshold--label">
              <span>${incentives_goals[i].label}</span>
              <span>$${(incentives_goals[i].threshold /100)}</span>
            </div>
          </div>
        `;
      }

      cart_rewards.insertAdjacentHTML("beforebegin", `
        <div class="js-incentives">
          <div class="js-incentives-mesage">Status...</div>
          <div class="js-incentives--bar">
            <div class="js-incentives--bar--filled"></div>
            <div class="js-incentives--goals">
              ${thresholds_html}
            </div>
          </div>
        </div>
      `);

      const update_incentives_module = (current_cart_subtotal) => {

        let incentives_message = document.querySelector('.js-incentives-mesage')
        let incentives_bar_filled = document.querySelector('.js-incentives--bar--filled')
        let incentives_message_set = false;
        let earned_incentives = [];

        if(current_cart_subtotal >= incentives_max){
          incentives_bar_filled.style.width = "100%";
          incentives_message.innerHTML = `<strong>FREE STUFF</strong> is headed your way!`;
        } else {
          incentives_bar_filled.style.width = `${(current_cart_subtotal / incentives_max) * 100}%`;
        }

        let incentives_thresholds = document.querySelectorAll('.js-incentives--threshold');
        for(let i = 0; i < incentives_thresholds.length; i++){

          let incentives_message_html = "";

          let threshold_amount = parseInt(incentives_thresholds[i].getAttribute("data-threshold"));
          let threshold_label = incentives_thresholds[i].getAttribute("data-label");
          let threshold_var_id = incentives_thresholds[i].getAttribute("data-var-id");

          if(current_cart_subtotal >= threshold_amount){
            incentives_thresholds[i].classList.add('js-threshold-met');
            incentives_thresholds[i].classList.add('js-reveal');
            if(threshold_var_id != "none"){
              earned_incentives.push(threshold_var_id);
              console.log("earned_incentives", earned_incentives)
            }
          } else {
            incentives_thresholds[i].classList.remove('js-threshold-met');
            incentives_thresholds[i].classList.remove('js-reveal');
          }

          if(!incentives_message_set){
            if(current_cart_subtotal < threshold_amount){
              incentives_message_html = `Only $${((threshold_amount - current_cart_subtotal)/100).toFixed(0)} away from <strong>${threshold_label}</strong>`;

              incentives_message.innerHTML = incentives_message_html;
              incentives_message_set = true;
            }
          }

          if(i == incentives_thresholds.length - 1){
            // last loop

            let items_to_auto_add = [];

            for(let ii = 0; ii < earned_incentives.length; ii++){

              // check if the free item already exists in cart, do not add it again, and mark as FREE
              if(document.querySelector('.cart__main').innerHTML.indexOf(`?variant=${earned_incentives[ii]}`) == -1){
                items_to_auto_add.push(earned_incentives[ii])
              } else {
                if(document.querySelectorAll(`.cart__main a[href*="?variant=${earned_incentives[ii]}"]`).length > 0){
                  document.querySelector(`.cart__main a[href*="?variant=${earned_incentives[ii]}"]`).parentNode.parentNode.classList.add("js-free");
                }
              }

              if(ii == earned_incentives.length -1){
                // last loop
                if(items_to_auto_add.length > 0){

                  cart_add_item(items_to_auto_add[0], 1, () => {
                    if(items_to_auto_add.length > 1){
                      cart_add_item(items_to_auto_add[1], 1, () => {
                        window.location = window.location.origin + window.location.pathname + "?cart=open&qa=DS-03";
                      });
                    } else {
                      window.location = window.location.origin + window.location.pathname + "?cart=open&qa=DS-03";
                    }
                  });

                }

              }
            }
          }

        }

      }

      const review_cart_items = () => {
        observeSelector('.cart__main .items-center a', cart_item => {
          if(!!cart_item.parentNode.querySelector('[x-price]') && cart_item.parentNode.querySelector('[x-price]').innerText == "$0"){

            if(cart_item.href.indexOf("31903251169362") > -1){
              cart_item.parentNode.querySelector('[x-price]').innerHTML = "<s>$3</s> <strong>FREE</strong>";
            } else if(cart_item.href.indexOf("30982564610130") > -1){
              cart_item.parentNode.querySelector('[x-price]').innerHTML = "<s>$12</s> <strong>FREE</strong>";
            } else if(cart_item.href.indexOf("40806724337835") > -1){
              cart_item.parentNode.querySelector('[x-price]').innerHTML = "<s>$30</s> <strong>FREE</strong>";
            } else {
              cart_item.parentNode.querySelector('[x-price]').innerHTML = "FREE"
            }

          }
        });
      };

      observeSelector('.cart__footer form button[type="submit"] > span:last-child', cart_subtotal => {

        // init incentives bar
        update_incentives_module((parseFloat(cart_subtotal.innerText.replace("$", "")).toFixed(2)) * 100);

        const innerText_observer = new MutationObserver(function(mutationsList) {
          for (let mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.target === cart_subtotal) {

              const new_InnerText = cart_subtotal.innerText;
              let cart_subtotal_price = parseFloat(new_InnerText.replace("$", "")).toFixed(2);
              update_incentives_module(cart_subtotal_price * 100);
              review_cart_items();
            }
          }
        });

        const observerConfig = { childList: true, subtree: true };
        innerText_observer.observe(cart_subtotal, observerConfig);

      });

    });

  });

}).catch()

/* ----------

  [DS - 05] Homepage Hero Video
  v2: places video

---------- */

waitUntil(() => {
  return window.sessionStorage.getItem("DS-05") || !!false;
}).then(() => {

  waitForElement('body.template-index').then(() => {

    let exp_id = "DS-05";
    let exp_var = "v2";
    console.log(`init [${exp_id}] -- 0.01 -- ${exp_var}`);

    waitForElement('#shopify-section-template--15984055189675__hero').then(hp_hero => {

        let height_setting = "auto";
        let width_setting = "100%";

        if(window.innerHeight * 1.5 > window.innerWidth){
           height_setting = "100%";
           width_setting = "auto";
        }

        hp_hero.classList.add("js-hp-hero");
        hp_hero.insertAdjacentHTML("afterbegin", `
            <style>

            .js-hp-hero{
                overflow: hidden;
                position: relative;
            }

            .js-hp-hero video{
                opacity: 1;
                position: absolute;
                z-index: 1;
                top: 50%;
                left: 50%;
                transform: translateY(-50%) translateX(-50%);
                height: ${height_setting};
                width: ${width_setting};
            }
            </style>

            <video id="js-hp-hero-video" autoplay="autoplay" loop="loop" playsinline="playsinline" class="media-video" muted="muted" preload="none" aria-label="The freshest spices start with farmers">
            <source src="https://cdn.shopify.com/videos/c/o/v/a6f672df4bf34252b52425a7c9ddf4de.mp4" type="video/mp4">
            </video>

        `);

    }).catch();

  }).catch();

}).catch();

/* ----------

  [DS-07] AOV Incentivization
  v1: simplified collections w incentive

---------- */

waitUntil(() => {
  return window.sessionStorage.getItem("DS-07") || !!true;
}).then(() => {

  observeSelector('body', doc => {

    let exp_id = "DS-07";
    let exp_var = "v1";
    console.log(`init [${exp_id}] -- 0.02 -- ${exp_var}`);

    doc.insertAdjacentHTML("afterbegin", `
      <style>
        .js-hidden{
          display: none;
          opacity: 0;
          position: absolute;
          left: -9999px;
        }

        /* --- START INCENTIVES MODULE --- */

        .collection-subhead .sticky h2{
          transition: .5s ease all;
          padding-top: 5rem;
        }

        [data-spice-in-cart="0"] .collection-subhead .sticky h2{
          padding-top: 0;
        }

        #js-incentives-module{
          transition: .5s ease all;
          position: absolute;
          top: 5rem;
          left: 1rem;
          border: 5px solid #D5137B;
          width: calc(320px - 1rem);
          padding: 1rem;
          background: #FAE600;
          border-radius: .75rem;
          opacity: 1;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          font-weight: 800;
          margin-bottom: 0.2em;
          font-size: 0.625em;
        }

        #js-incentives-module--in-cart{
          transition: .5s ease all;
          padding: 1rem 1rem 2rem 1rem;
          background: #FAE600;
          border-radius: .75rem;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          font-weight: 800;
          margin-bottom: 0.2em;
          font-size: 0.625em;
        }

        #js-incentives-module .js-big-pink{
          color: #d5137b;
          font-size: .85rem;
          display: block;
        }

        [data-spice-in-cart="0"] #js-incentives-module{
          opacity: 0;
        }

        .js-progress-bar{
          height: 5px;
          width: 100%;
          position: relative;
          top: 4px;
          border-radius: 25px;
          background: #ffbb00;
        }

        .js-progress-bar--filled{
          transition: .5s ease all;
          background: #d5137b;
          position: absolute;
          width: 0%;
          max-width: 100%;
          top: 0;
          left: 0;
          height: 5px;
          border-radius: 25px;
        }

        [class*="js-progress-bar--dot"]{
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 14px;
          height: 14px;
          border-radius: 100%;
          background: #ffbb00;
          transition: .5s ease all;
        }

        .js-progress-bar--dot--1{
          left: calc(25% - 7px);
        }

        .js-progress-bar--dot--2{
          left: calc(50% - 7px);
        }

        .js-progress-bar--dot--3{
          left: calc(75% - 7px);
        }

        .js-progress-bar--dot--4{
          left: calc(100% - 7px);
        }

        [data-pack-progress="1"] .js-progress-bar--dot--1,
        [data-pack-progress="2"] .js-progress-bar--dot--1,
        [data-pack-progress="2"] .js-progress-bar--dot--2,
        [data-pack-progress="3"] .js-progress-bar--dot--1,
        [data-pack-progress="3"] .js-progress-bar--dot--2,
        [data-pack-progress="3"] .js-progress-bar--dot--3,
        [data-pack-progress="4"] .js-progress-bar--dot--1,
        [data-pack-progress="4"] .js-progress-bar--dot--2,
        [data-pack-progress="4"] .js-progress-bar--dot--3,
        [data-pack-progress="4"] .js-progress-bar--dot--4{
          background: #d5137b;
        }

        #js-incentives-module--in-cart .js-progress-bar--dot--1:after,
        #js-incentives-module--in-cart .js-progress-bar--dot--2:after,
        #js-incentives-module--in-cart .js-progress-bar--dot--3:after,
        #js-incentives-module--in-cart .js-progress-bar--dot--4:after{
          position: absolute;
          top: 1rem;
          left: -20px;
          white-space: nowrap;
          width: 50px;
          text-align: center;
          color: #d5137b;
          font-weight: 600;
          content: "";
          opacity: 0;
        }

        #js-incentives-module--in-cart[data-pack-progress="0"] .js-progress-bar--dot--1:after {
          content: "3 Tins";
          opacity: 1;
        }

        #js-incentives-module--in-cart[data-pack-progress="1"] .js-progress-bar--dot--2:after {
          content: "6 Tins";
          opacity: 1;
        }

        #js-incentives-module--in-cart[data-pack-progress="2"] .js-progress-bar--dot--3:after {
          content: "9 Tins";
          opacity: 1;
        }

        #js-incentives-module--in-cart[data-pack-progress="3"] .js-progress-bar--dot--4:after,
        #js-incentives-module--in-cart[data-pack-progress="4"] .js-progress-bar--dot--4:after{
          content: "12 Tins";
          left: -30px;
          opacity: 1;
        }

        @media(max-width: 1000px){
          .filter-wrapper.js-dropdown-wrapper{
            display: none;
            position: absolute;
            left: -9999px;
            opacity: 0;
          }
          .collection-subhead .sticky h2{
            padding-top: 1rem;
          }

          #js-incentives-module{
            left: auto;
            right: 1.5rem;
          }
        }

        @media(max-width: 650px){

          #js-incentives-module{
            right: auto;
            left: 50%;
            transform: translateX(-50%);
            top: calc(100vh - 210px);
          }
        }

      </style>
    `);

    // observeSelector('.cart__main [class*="bg-gold-light"]', cart_message => {
    //   cart_message.classList.add("js-hidden");
    //   if(document.querySelectorAll('#js-incentives-module--in-cart').length == 0){
    //     cart_message.insertAdjacentHTML("afterend", `
    //     <div id="js-incentives-module--in-cart">
    //       <div class="js-box-text">Save on tins in packs of 3</div>
    //       <div class="js-total-saved"></div>
    //       <div class="js-big-pink"></div>
    //       <div class="js-progress-bar">
    //         <div class="js-progress-bar--filled"></div>
    //         <div class="js-progress-bar--dot--1"></div>
    //         <div class="js-progress-bar--dot--2"></div>
    //         <div class="js-progress-bar--dot--3"></div>
    //         <div class="js-progress-bar--dot--4"></div>
    //       </div>
    //     </div>
    //     `);
    //   }
    // })

    waitForElement('#scrolling-navigation').then(sticky_nav => {
      sticky_nav.insertAdjacentHTML("beforeend", `
        <div id="js-incentives-module">
          <div class="js-box-text">Save on tins in packs of 3</div>
          <div class="js-total-saved"></div>
          <div class="js-big-pink"></div>
          <div class="js-progress-bar">
            <div class="js-progress-bar--filled"></div>
            <div class="js-progress-bar--dot--1"></div>
            <div class="js-progress-bar--dot--2"></div>
            <div class="js-progress-bar--dot--3"></div>
            <div class="js-progress-bar--dot--4"></div>
          </div>
        </div>
      `);

      const update_incentives_module = (incentives_module_id) => {

        let tins_count = Math.floor(document.documentElement.getAttribute("data-spice-in-cart"));
        let packs_count = Math.floor(document.documentElement.getAttribute("data-spice-in-cart")/3);
        let to_next_pack = 3 - (document.documentElement.getAttribute("data-spice-in-cart")%3);

        if(packs_count >= 4){
          packs_count = 4;
          to_next_pack = 0;
        }

        const savings_thresholds = {
          1: "1.50",
          2: "3.50",
          3: "6.00",
          4: "9.00"
        };

        let class_if_zero_packs = tins_count == 0 ? "js-hidden" : "";
        let class_if_not_zero_packs = tins_count > 0 ? "js-hidden" : "";

        if(document.querySelectorAll(`#${incentives_module_id}`).length > 0){

          console.log("do the update_incentives_module()")

          let incentives_module = document.querySelector(`#${incentives_module_id}`);

          // incentives_module.setAttribute("data-pack-progress", document.documentElement.getAttribute("data-spice-in-cart")%3);
          incentives_module.setAttribute("data-pack-progress", packs_count);

          incentives_module.querySelector('.js-box-text').classList.value =  `js-box-text ${class_if_not_zero_packs}`;
          incentives_module.querySelector('.js-total-saved').classList.value =`js-total-saved ${class_if_zero_packs}`;

          observeSelector('[data-pack-progress] .js-progress-bar--filled', filled_bar => {
            filled_bar.style.width = `${(tins_count/12)*100}%`;
          });

          if(tins_count > 11){
            incentives_module.querySelector('.js-total-saved').innerHTML = "";
            incentives_module.querySelector('.js-big-pink').innerHTML = `You've saved $${savings_thresholds[packs_count]}`;
          } else if(tins_count > 2){
            incentives_module.querySelector('.js-total-saved').innerHTML = `You've saved $${savings_thresholds[packs_count]} on spice tins`;
            incentives_module.querySelector('.js-big-pink').innerHTML = `add ${to_next_pack} more to save $${savings_thresholds[packs_count + 1]}`;
          } else {
            incentives_module.querySelector('.js-total-saved').innerHTML = "Save on tins in packs of 3";
            incentives_module.querySelector('.js-big-pink').innerHTML = `add ${to_next_pack} more to save $${savings_thresholds[packs_count + 1]}`;
          }
        }

      };

      // init
      update_incentives_module('js-incentives-module');
      update_incentives_module('js-incentives-module--in-cart');

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-cart-qty') {
            console.log("qty updated")
            update_incentives_module('js-incentives-module');
            update_incentives_module('js-incentives-module--in-cart');
          }
        }
      });

      observer.observe(document.documentElement, { attributes: true });
    }).catch();

  });
}).catch();
